import Cookies from "universal-cookie";

const cookies = new Cookies();

// Base URL of the dedicated back-office API (its own RestApi, separate from SERVER_URL because the
// main API is at the CloudFormation 500-resource ceiling). Set BACKOFFICE_SERVER_URL in the env file.
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const backofficeFetch = async (path) => {
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(`${BASE}${path}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
};

const enc = encodeURIComponent;
const bq = (buildingId) => (buildingId ? `&building_id=${enc(buildingId)}` : "");

export const fetchExplorerCompanies = () => backofficeFetch(`/supplierExplorer/companies`);

export const fetchExplorerBuildings = (companyId) =>
  backofficeFetch(`/supplierExplorer/buildings?company_id=${enc(companyId)}`);

export const fetchExplorerSuppliers = (companyId, buildingId) =>
  backofficeFetch(`/supplierExplorer?company_id=${enc(companyId)}${bq(buildingId)}`);

export const fetchExplorerSupplier = (companyId, supplierId, buildingId) =>
  backofficeFetch(
    `/supplierExplorer/supplier?company_id=${enc(companyId)}&supplierId=${enc(supplierId)}${bq(buildingId)}`
  );

export const fetchExplorerMaterials = (companyId, buildingId) =>
  backofficeFetch(`/supplierExplorer/materials?company_id=${enc(companyId)}${bq(buildingId)}`);

export const fetchExplorerMaterial = (companyId, material, buildingId) =>
  backofficeFetch(
    `/supplierExplorer/material?company_id=${enc(companyId)}&material=${enc(material)}${bq(buildingId)}`
  );

export const fetchCrossClientSuppliers = () => backofficeFetch(`/supplierExplorer/crossClient`);

export const fetchCrossClientSupplier = (cnpj) =>
  backofficeFetch(`/supplierExplorer/crossClient/supplier?cnpj=${enc(cnpj)}`);
